var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconCalendararchive18 = function SvgAIconCalendararchive18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 12.7333H2.06667C1.47756 12.7333 1 12.2558 1 11.6667V3.13332C1 2.54421 1.47756 2.06665 2.06667 2.06665H11.6667C12.2558 2.06665 12.7333 2.54421 12.7333 3.13332V6.33332",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.26669H12.7333",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19922 3.13333V1",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53418 3.13333V1",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7325 17C15.0889 17 16.9992 15.0897 16.9992 12.7333C16.9992 10.3769 15.0889 8.46664 12.7325 8.46664C10.3761 8.46664 8.46582 10.3769 8.46582 12.7333C8.46582 15.0897 10.3761 17 12.7325 17Z",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6193 12.7333H12.7334V10.8482",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconCalendararchive18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik02LjMzMzMzIDEyLjczMzNIMi4wNjY2N0MxLjQ3NzU2IDEyLjczMzMgMSAxMi4yNTU4IDEgMTEuNjY2N1YzLjEzMzMyQzEgMi41NDQyMSAxLjQ3NzU2IDIuMDY2NjUgMi4wNjY2NyAyLjA2NjY1SDExLjY2NjdDMTIuMjU1OCAyLjA2NjY1IDEyLjczMzMgMi41NDQyMSAxMi43MzMzIDMuMTMzMzJWNi4zMzMzMiIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTEgNS4yNjY2OUgxMi43MzMzIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNNC4xOTkyMiAzLjEzMzMzVjEiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik05LjUzNDE4IDMuMTMzMzNWMSIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi43MzI1IDE3QzE1LjA4ODkgMTcgMTYuOTk5MiAxNS4wODk3IDE2Ljk5OTIgMTIuNzMzM0MxNi45OTkyIDEwLjM3NjkgMTUuMDg4OSA4LjQ2NjY0IDEyLjczMjUgOC40NjY2NEMxMC4zNzYxIDguNDY2NjQgOC40NjU4MiAxMC4zNzY5IDguNDY1ODIgMTIuNzMzM0M4LjQ2NTgyIDE1LjA4OTcgMTAuMzc2MSAxNyAxMi43MzI1IDE3WiIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTE0LjYxOTMgMTIuNzMzM0gxMi43MzM0VjEwLjg0ODIiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";